import React     from 'react'
import PropTypes from 'prop-types'

import { translateBool, formatDate        } from 'alto-utils/lib/utils'
import { AdminForm, AdminTable, AdminPage } from 'alto-react-components/lib/components'
import CanteenRepository, { Meal }          from 'alto-react-canteen/lib/models'

class MealTable extends AdminTable
  @contextTypes = { backend: PropTypes.object }

  model: Meal

  constructor: (props, context) ->
    super(props, context)

    @state.canteens        = null
    @state.courses         = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám seznam jídelen a chodů'

    repository = CanteenRepository.forBackend(context.backend)

    Promise.all([repository.canteens.all(),
                 repository.courses.orderBy('orderNumber').all()])
      .then ([canteens, courses]) => @setState({ canteens, courses, ready: true })

  columns: ->
    canteenOptions = @state.canteens.map (canteen) -> [canteen.name, canteen.name]
    courseOptions  = @state.courses.map  (course)  -> [course.displayName, course.displayName]

    [{
       _property: 'canteen.name'
       property: (meal) -> meal.associations.canteen.name
       header:
         label: 'Jídelna'
         formatters: [@orderableAndFilterable(type: 'select', options: canteenOptions)]
       filter:
         matcher: 'icontains'
     }, {
       property: 'date'
       header:
         label: 'Datum'
         formatters: [@orderableAndFilterable(type: 'date')]
       filter:
         matcher: 'exact'
       cell:
         formatters: [(date) -> date.format('D.M.YYYY')]
     }, {
       _property: 'course.displayName'
       property: (meal) -> meal.associations.course.displayName
       header:
         label: 'Chod'
         formatters: [@orderableAndFilterable(type: 'select', options: courseOptions)]
       filter:
         matcher: 'icontains'
     }, {
       property: 'number'
       header:
         label: 'Číslo'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       property: 'stockCardNumber'
       header:
         label: 'Číslo skladové karty'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       property: 'name'
       header:
         label: 'Název'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }]

class MealForm extends AdminForm
  @contextTypes = { backend: PropTypes.object }

  model: Meal

  constructor: (props, context) ->
    super(props, context)

    @state.canteens        = null
    @state.courses         = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám seznam jídelen a chodů'

    repository = CanteenRepository.forBackend(context.backend)

    Promise.all([repository.canteens.all(),
                 repository.courses.orderBy('orderNumber').all()])
      .then ([canteens, courses]) => @setState({ canteens, courses, ready: true })

  inputs: ->
    canteenOptions = @state.canteens.map (canteen) -> [canteen.name, canteen.id]
    courseOptions  = @state.courses.map  (course)  -> [course.displayName, course.name]

    [{
       type:       'select'
       label:      'Jídelna'
       property:   'canteenID'
       options:    canteenOptions
     }, {
       type:       'date'
       label:      'Datum'
       property:   'date'
     }, {
       type:       'select'
       label:      'Chod'
       property:   'courseName'
       options:    courseOptions
     }, {
       label:      'Číslo'
       property:   'number'
       type:       'integer'
       validator:  'notEmpty'
     }, {
       label:      'Číslo skladové karty'
       property:   'stockCardNumber'
       type:       'integer'
       validator:  'notEmpty'
     }, {
       label:      'Název'
       property:   'name'
       validator:  'notEmpty'
     }, {
       label:      'Popisek'
       property:   'description'
     }, {
       type:       'checkbox'
       label:      'Zobrazit na webu'
       property:   'showOnWeb'
     }, {
       type:       'select'
       label:      'Doplňkový chod'
       property:   'additionalCourseName'
       options:    courseOptions
       allowBlank: true
     }, {
       type:       'integer'
       label:      'Výchozí číslo doplňkového chodu'
       property:   'additionalCourseDefaultNumber'
     }]

export default class MealManagement extends AdminPage
  @contextTypes = { backend: PropTypes.object }

  tableComponent: MealTable
  formComponent:  MealForm

  relation: ->
    @__relation ?= CanteenRepository.forBackend(@context.backend)
      .meals.with('canteen', 'course', 'additionalCourse')
